import { useQuery } from '@apollo/client/react/hooks';
import SpinnerMono from '@clearkit/icons/indicators/SpinnerMono';
import moment from 'moment';

import ActiveIntegrationCard from './ActiveIntegrationCard';
import activeIntegrationsQuery from './activeIntegrationsQuery.graphql';
import ActiveIntegrationsTimeRangeFilters from './ActiveIntegrationsTimeRangeFilters';

function ActiveIntegrationsList() {
  // Set as last 7 days window by default
  const [queryStartDate, setQueryStartDate] = useState(moment().add(-7, 'day'));
  const { data: { accountConnectors } = {}, loading: loading } = useQuery(
    activeIntegrationsQuery,
    {
      fetchPolicy: 'no-cache',
    },
  );
  return (
    <div className="px-10 py-6">
      <ActiveIntegrationsTimeRangeFilters
        queryStartDate={queryStartDate}
        setQueryStartDate={setQueryStartDate}
      />
      <h3 className="mb-4 text-base font-medium">Active Integrations</h3>
      {loading ? (
        <SpinnerMono />
      ) : (
        accountConnectors?.map((ac) => (
          <ActiveIntegrationCard
            queryStartDate={queryStartDate}
            key={ac.id}
            accountConnector={ac}
          />
        ))
      )}
    </div>
  );
}

export default ActiveIntegrationsList;
